import { Vue, Component } from 'vue-property-decorator';


@Component({
    name: 'usage-content',
})

export default class UsageContent extends Vue {
    // ---------------------------------------------------------------------
    // Properties

    public getBackFlow() {
        this.$router.push('/dashboard');
    }
}
